import type { CoreTypes } from '../../core';

export function division (input: unknown): undefined | Pick<CoreTypes.Deep.Division, 'displayName' | 'start' | 'end'> {

  if (                                !input               || typeof input               != 'object'
    || !('meta'     in input     ) || !input.meta          || typeof input.meta          != 'object'
    || !('division' in input.meta) || !input.meta.division || typeof input.meta.division != 'object'
  ) return;

  const d = input.meta.division;

  if (!('displayName' in d && typeof d.displayName == 'string')) return;
  if (!('start'       in d && typeof d.start       == 'string')) return;
  if (!('end'         in d && typeof d.end         == 'string')) return;

  const division: Pick<CoreTypes.Deep.Division, 'displayName' | 'start' | 'end'> = {
    displayName: d.displayName,
    start:       d.start,
    end:         d.end,
  };
  return division;
};